import { CommonModule } from '@angular/common';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { ThumbnailUrlService } from '@shared/services/thumbnail-url.service';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ThumbnailRendererParams } from './interfaces';
import { ImagePreviewDialogService } from '@shared/components/image-preview-dialog/image-preview-dialog.service';

@Component({
  selector: 'app-thumbnail-renderer',
  templateUrl: './thumbnail-renderer.component.html',
  styleUrls: ['./thumbnail-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule],
})
export class ThumbnailRendererComponent implements ICellRendererAngularComp {
  private thumbnailUrlService = inject(ThumbnailUrlService);
  private imgPreviewService = inject(ImagePreviewDialogService);

  private params: ThumbnailRendererParams;

  safeUrl: SafeResourceUrl | undefined;

  agInit(params: ThumbnailRendererParams): void {
    this.params = params;
    this.safeUrl = this.thumbnailUrlService.getSafeUrl(params.value);
  }

  refresh = (params: ThumbnailRendererParams): boolean => {
    this.safeUrl = this.thumbnailUrlService.getSafeUrl(params.value);

    return true;
  };

  displayFullImg(): void {
    const attachmentIdKey = this.params.attachmentIdKey;

    const attachmentId = attachmentIdKey
      ? // need to get node data manually to ensure getting the most up to date value
        this.params.api.getRowNode(this.params.node.id!)?.data?.[
          attachmentIdKey
        ]
      : undefined;

    if (!this.safeUrl || !attachmentId || !this.params.enablePreviewOnClick)
      return;

    this.imgPreviewService.openFullImageDialog({
      attachmentId,
    });
  }
}
